<h2 mat-dialog-title>Save Refinery</h2>

<mat-dialog-content>
<p>
    <mat-form-field>
        <input required matInput placeholder="Refinery Name" [(ngModel)]="name">
    </mat-form-field>
</p>
<p>
    <mat-form-field>
        <textarea required matInput placeholder="Description" [(ngModel)]="description"></textarea>
    </mat-form-field>
</p>
<p>
    <mat-form-field>
        <mat-select required [(value)]="selectedStatus">
            <mat-option *ngFor="let option of refineryStatus" [value]="option">
                {{RefineryStatusUtil.toString(option)}}
            </mat-option>
        </mat-select> 
    </mat-form-field>
</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button (click)="save()" color="primary" mat-raised-button tabindex="-1">SAVE</button>
    <button (click)="cancel()" mat-raised-button mat-dialog-close tabindex="-1">CANCEL</button>
</mat-dialog-actions>
